import { useEffect, useState } from 'react'
import { usePlatformStore } from '@/stores/platform.store'

/** Ready when platform token store finished rehydrating from sessionStorage. */
export function usePlatformHydrated(): boolean {
  const hasToken = usePlatformStore((s) => !!s.token)
  const [hydrated, setHydrated] = useState(() => usePlatformStore.persist.hasHydrated())

  useEffect(() => {
    const mark = () => setHydrated(usePlatformStore.persist.hasHydrated())
    mark()
    return usePlatformStore.persist.onFinishHydration(mark)
  }, [])

  return hydrated || hasToken
}
